  <div class="row">
    <div class="col-print-12 padding-left-0px padding-right-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Purchase Order</label>
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px bordertop">
            <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10">
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Name of the Center:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{BranchName}}
                    </label>
                  </div>
                </div>-->
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Name of the Vendor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.DisplayName}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Address Line:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.AddressLine1}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">City / Pincode:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.City}} / {{VendorData.ZipCode}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">State / Country:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.State}} / {{VendorData.Country}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Telephone:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.Telephone1}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="VendorData">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Fax:</label>
                  </div>
                  <div class="col-print-6">                    
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{VendorData.VendorFax}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Vendor doc number:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.RefNo}}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10">

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">PO Number:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode}}
                    </label>
                  </div>
                </div>

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.OrderDate | date:'MMM-dd-yyyy'}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Counter Person:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.CounterPerson}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Telephone / Fax:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.Telephone1}} / {{CurrentPurchaseOrderHeaderDetailsController.Fax1}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Ref your quote no:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Delivery Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{CurrentPurchaseOrderHeaderDetailsController.DeliveryDate | date:'MMM-dd-yyyy'}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-bold">Please deliver to:</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px bordertop border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Name of the Center:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{BranchName}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Address Line1:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Address Line2:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">City / Pincode:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">State / Country:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Telephone:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Fax:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">TIN:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">
                      {{TIN}}
                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">C.S.T.NO.:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>-->
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-normal">Kind Attention:</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-normal">
                  We are pleased to place order for supply of materials as mentioned below:
                </label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          #
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Item Description
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Qty
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Bns Qty
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Uom
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Unit
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Total
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Disc%
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Disc Amt
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Tax%
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Tax Amt
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          MRP
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family padding-left-5px padding-right-5px">
                          Net
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentPurchaseOrderDetailsController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.MaterialCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.MaterialDescription}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">
                          {{l.TotalOrderQuantity}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.BonusQuantity}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.UOM}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.UnitPrice | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.TotalAmount | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.DiscountPercent}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.DiscountAmount | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.TaxPercent}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.TaxAmount | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.MRP | number:'1.0-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px padding-left-5px padding-right-5px">{{l.Net | number:'1.0-2'}}</td>

                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-bold">Bill Summary:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-right-0px margin-left-0px">
              <div class="col-print-6">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                            Total
                          </th>

                          <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                            Discount
                          </th>
                          <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                            Tax
                          </th>
                          <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                            Net
                          </th>
                          <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                    Due
                  </th>-->

                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                            {{CurrentPurchaseOrderHeaderDetailsController.TotalBeforeDiscount | number:'1.2-2'}}
                          </td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                            {{CurrentPurchaseOrderHeaderDetailsController.DiscountAmount | number:'1.2-2'}}
                          </td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                            {{CurrentPurchaseOrderHeaderDetailsController.Tax | number:'1.2-2'}}
                          </td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-right">
                            {{CurrentPurchaseOrderHeaderDetailsController.Net | number:'1.2-2'}}
                          </td>
                          <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{Due | number:'1.2-2'}}</td>-->
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
              <div class="col-print-10">
                <label class="margin-bottom-0px font-family font-weight-normal">Amount In Words: {{CurrentPurchaseOrderHeaderDetailsController.Net | amountToWord}}</label>
              </div>
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CurrentPurchaseOrderHeaderDetailsController.Net | number:'1.2-2'}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-10">
                <label class="margin-bottom-0px font-family font-weight-normal">Terms and Conditions:</label>
              </div>
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
              <div class="col-print-11">
                <label class="margin-bottom-0px font-family font-weight-normal">
                  {{CurrentPurchaseOrderHeaderDetailsController.TermsAndConditions}}
                </label>
              </div>
              <!--<div class="col-print-2">
        <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
      </div>-->
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Authorised Signatory</label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-7">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                </div>
              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">

                    </label>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-family font-weight-normal">
                  ** Please see overleaf for standard terms & conditions.
                </label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-family font-weight-normal">
                  *** If there is any conflict between the standard terms & conditions and
                </label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-family font-weight-normal">
                  the above terms & conditions will supersede the standard terms & conditions.
                </label>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
  </div>




